import Vue from 'vue';
import VueRouter from 'vue-router';
import config from '../config.js';
import store from '../store';
import JwtService from '../services/jwt.service';
import ProfilePage from '../views/Profile.vue';
import LoginPage from '../views/LoginPage.vue';
import NotFoundPage from '../views/NotFoundPage.vue';
import ClientConfigPage from '../views/ClientConfigPage.vue';
import accountRoutes from './account.routes.js';
import adminsRoutes from './admins.routes.js';
import ProfileService from '../services/permissions.service';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/account'
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: {
      title: 'profile',
      requiresAuth: true,
      hideBreadcrumb: true,
      action: 'views.profile.read'
    }
  },
  {
    path: '/config',
    name: 'config',
    component: ClientConfigPage,
    meta: {
      title: 'profile',
      requiresAuth: true,
      hideBreadcrumb: true,
      action: 'views.clientConfig.read'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: { title: 'login' }
  },
  { path: '*', component: NotFoundPage, redirect: { name: 'account' } },
  { path: '', component: NotFoundPage, redirect: { name: 'account' } },
  ...adminsRoutes,
  ...accountRoutes
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
const hasQueryParams = (route) => {
  return !!Object.keys(route.query).length;
};

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.state.userData) {
      const token = JwtService.getSessionToken();
      if (token) {
        await store.dispatch('setApiKey');
        next();
      } else if (config.isLocal) {
        next('/login');
        location.reload();
      } else {
        window.location.href = config.serviceUrl;
      }
    } else {
      if (!hasQueryParams(to) && hasQueryParams(from)) {
        next({ name: to.name, query: from.query, params: to.params });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.beforeResolve(async (to, from, next) => {
  if (to.meta.action) {
    const navigationAllowed = await ProfileService.canExecute(to.meta.action);
    if (!navigationAllowed) {
      next('/');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
